// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectableTag_root__2Nb3U","selected":"SelectableTag_selected__x-UlU"};